export default "__VITE_ASSET__DIckPDZU__"